import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
  SidebarSpacer,
} from '@backstage/core-components';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { ThemedSidebarDivider } from '../../theme/common';
import { DaimlerIcons } from '../icons/DaimlerIcons';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarSpacer />
      <SidebarGroup
        label="Search"
        icon={<DaimlerIcons.Search className="sidebar-icon" />}
        to="/search"
      >
        <SidebarSearchModal />
      </SidebarGroup>
      <ThemedSidebarDivider />
      <SidebarGroup
        label="Menu"
        icon={<DaimlerIcons.Menu className="sidebar-icon" />}
      >
        {/* Global nav, not org-specific */}
        <SidebarItem icon={DaimlerIcons.Home} to="/" text="Home" />
        <SidebarItem icon={DaimlerIcons.Catalog} to="catalog" text="Catalog" />
        <SidebarItem icon={DaimlerIcons.API} to="api-docs" text="APIs" />
        <SidebarItem icon={DaimlerIcons.Docs} to="docs" text="Docs" />
        <SidebarItem icon={DaimlerIcons.Create} to="create" text="Create..." />
        {/* End global nav */}
        <SidebarSpacer />
        <SidebarScrollWrapper>
          {/* Items in this group will be scrollable if they run out of space */}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <NotificationsSidebarItem />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
      <SidebarItem icon={DaimlerIcons.Build} to="devtools" text="DevTools" />
    </Sidebar>
    {children}
  </SidebarPage>
);
